var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0.75C2.42625 0.75 0.75 2.42625 0.75 4.5C0.75 6.57375 2.42625 8.25 4.5 8.25C6.57375 8.25 8.25 6.57375 8.25 4.5C8.25 2.42625 6.57375 0.75 4.5 0.75ZM6.375 5.84625L5.84625 6.375L4.5 5.02875L3.15375 6.375L2.625 5.84625L3.97125 4.5L2.625 3.15375L3.15375 2.625L4.5 3.97125L5.84625 2.625L6.375 3.15375L5.02875 4.5L6.375 5.84625Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0.75C2.42625 0.75 0.75 2.42625 0.75 4.5C0.75 6.57375 2.42625 8.25 4.5 8.25C6.57375 8.25 8.25 6.57375 8.25 4.5C8.25 2.42625 6.57375 0.75 4.5 0.75ZM6.375 5.84625L5.84625 6.375L4.5 5.02875L3.15375 6.375L2.625 5.84625L3.97125 4.5L2.625 3.15375L3.15375 2.625L4.5 3.97125L5.84625 2.625L6.375 3.15375L5.02875 4.5L6.375 5.84625Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.afeac20b.svg";
export { ForwardRef as ReactComponent };